//
//
//
//


import { axiosGet } from '../../axios/axios.js'

export default {
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    requestInitial: {
      type: Object,
      default () {
        return {}
      }
    },
    isInitialize: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'request.requestType': function () {
      this.computeRequestPriority()
    },
    'request.serviceObjectId': function () {
      this.computeRequestPriority()
    },
    'request.priorityCondition': function () {
      this.computeRequestPriority()
    },
    'request.requestSourceId': function () {
      this.computeRequestPriority()
    },
    'request.serviceObjectPriority': function () {
      this.computeRequestPriority()
    }
  },
  methods: {
    computeRequestPriority: function () {
      if (this.requestInitial && Object.keys(this.requestInitial).length && //
        this.request.requestType === this.requestInitial.requestType && //
        this.request.serviceObjectId === this.requestInitial.serviceObjectId && //
        this.request.priorityCondition === this.requestInitial.priorityCondition && //
        this.request.requestSourceId === this.requestInitial.requestSourceId && //
        this.request.serviceObjectPriority === this.requestInitial.serviceObjectPriority //
      ) {
        // Сбрасываем на исходное значение
        this.request.requestPriority = this.requestInitial.requestPriority
      } else if (this.request.requestType) {
        let requestUrl = '/service/delta/request/computePriority?typeId=' + this.request.requestType

        if (this.request.serviceObjectId) {
          requestUrl += '&serviceObjectId=' + this.request.serviceObjectId
        }
        if (this.request.priorityCondition) {
          requestUrl += '&conditionId=' + this.request.priorityCondition
        }
        if (this.request.requestSourceId) {
          requestUrl += '&sourceId=' + this.request.requestSourceId
        }
        if (this.request.serviceObjectPriority) {
          requestUrl += '&serviceObjectPriority=' + this.request.serviceObjectPriority
        }

        axiosGet({
          url: requestUrl,
          onSuccess: response => {
            this.$q.notify({
              type: 'positive',
              message: 'Автоматическое вычисление приоритета заявки',
              progress: true,
              timeout: 3000
            })
            this.request.requestPriority = Number(response.data.priority)
          },
          onFailure: 'Ошибка вычисления приоритета заявки'
        })
      } else {
        this.request.requestPriority = null
      }
    }
  }
}

